import {
  CONSOLE_ROUTES,
  ConsoleCreditLimitsSchema,
  ConsoleOverviewSchema,
  ConsoleUsageSchema,
} from '@plato/shared';
import { callConsoleApi } from './http-client.ts';
import type { UsageData } from './usage-data.ts';

export const httpUsageData: UsageData = {
  getUsage: (tenant, range) =>
    callConsoleApi(
      `${CONSOLE_ROUTES.usage(tenant)}?${new URLSearchParams({ from: range.from, to: range.to })}`,
      ConsoleUsageSchema,
    ),

  getCreditLimits: (tenant) =>
    callConsoleApi(CONSOLE_ROUTES.creditLimits(tenant), ConsoleCreditLimitsSchema),

  setCreditLimit: (tenant, limit) =>
    callConsoleApi(CONSOLE_ROUTES.creditLimits(tenant), ConsoleCreditLimitsSchema, {
      method: 'PUT',
      body: limit,
    }),

  removeCreditLimit: (tenant, kind, subject) =>
    callConsoleApi(
      `${CONSOLE_ROUTES.creditLimits(tenant)}?${new URLSearchParams({ kind, subject })}`,
      ConsoleCreditLimitsSchema,
      { method: 'DELETE' },
    ),

  getOverview: (tenant) => callConsoleApi(CONSOLE_ROUTES.overview(tenant), ConsoleOverviewSchema),
};
